let NotificationOptions = {
    jsTemplates: '#jsTemplates',
    templateType: 'notification',
    delay:4000
};

export class NotificationComponent {
    constructor() {
        this.options = NotificationOptions;
    }

    replaceTplWithMsg(type, msg) {
        let jsTemplates = document.querySelector(this.options.jsTemplates);
        jsTemplates = JSON.parse(jsTemplates.innerHTML);

        let tpl = jsTemplates[this.options.templateType]; // get "notification" template

        tpl = tpl
            .replace('{type}', type)
            .replace('{message}', msg);

        var d = document.createElement('div');
        d.innerHTML = tpl;
        return d.firstChild;
    }

    resolveDestination($dest) {
        if (!$dest) {
            return document.body;
        }

        if ($dest.nodeType) {
            return $dest;
        }

        if ($dest.jquery) {
            return $dest[0];
        }

        if ($dest[0]) {
            return $dest[0];
        }

        return document.body;
    }

    show(type, msg, $dest) {
        this.dest = this.resolveDestination($dest);

        this.tpl = this.replaceTplWithMsg(type, msg);
        this.tpl.classList.add('alert-js');
        this.tpl.classList.add('active');

        this.dest.insertBefore(this.tpl, this.dest.firstChild);
        this.tpl.addEventListener('click', this.close.bind(this.dest), false);


        let self = this;
        setTimeout(function () {
            self.tpl.click();
        }, self.options.delay);
    }

    close() { // scope : this.dest
        let node = this;
        setTimeout(function(){
            node.removeChild(node.firstChild);
         },1000);
    }
}

const resolveNotificationOpts = (e, showOpts) => {
    if (showOpts && showOpts.msg !== undefined) {
        return showOpts;
    }

    if (e && e.detail && e.detail.msg !== undefined) {
        return e.detail;
    }

    return null;
};

const handleNotification = (e, showOpts) => {
    const opts = resolveNotificationOpts(e, showOpts);

    if (!opts) {
        return;
    }

    let notif = new NotificationComponent();
    notif.show(opts.type, opts.msg, opts.dest);
};

const registerNotificationListener = () => {
    if (window.__wwpNotificationListenerRegistered) {
        return;
    }

    const $ = window.jQuery || window.$;

    if (!$) {
        setTimeout(registerNotificationListener, 50);
        return;
    }

    window.__wwpNotificationListenerRegistered = true;

    document.addEventListener('wwp:notification', (e) => {
        handleNotification(e, null);
    });

    $(document).on('notification', (e, showOpts) => {
        handleNotification(e, showOpts);
    });
};

registerNotificationListener();

window.pew.addRegistryEntry({key: 'wdf-notification', domSelector: '.contactForm', classDef: NotificationComponent});
